"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wrapper = exports.iframeContainer = exports.loaderContainer = exports.loader = void 0;
var loader = {
  base: {
    border: "16px solid white",
    borderTop: "16px solid #88b04b",
    borderRadius: "50%",
    width: "50px",
    height: "50px"
  },
  keyframes: [{
    color: "#fff",
    transform: "rotate(0deg)"
  }, {
    color: "#000",
    transform: "rotate(360deg)"
  }],
  keyframeOptions: {
    duration: 2000,
    easing: "linear",
    iterations: Infinity
  }
};
exports.loader = loader;
var loaderContainer = {
  background: "#EBF0F5",
  width: "100%",
  height: "100%",
  position: "absolute",
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
};
exports.loaderContainer = loaderContainer;
var iframeContainer = {
  width: "100%",
  height: "100%"
};
exports.iframeContainer = iframeContainer;
var wrapper = {
  width: "100%",
  height: "100%",
  position: "relative"
};
exports.wrapper = wrapper;